<div class="col-12 col-md-7 mt-3 me-3">
    <h1 class="h4">Import Quiz</h1>
    <div class="my-3">
        <app-upload-field #uploadField [(ngModel)]="files" (ngModelChange)="processFile()"
            acceptedExtensions=".json"></app-upload-field>
    </div>
</div>